import { z } from 'zod'

export const memberOpenedSchema = z.object({
  programUuid: z.string().uuid(),
  masterTaskId: z.string(),
  memberStatus: z.string(),
  taskList: z.array(z.object({
    uuid: z.string(),
    type: z.string(),
  })),
})
